import { render, staticRenderFns } from "./MensagemUpgrade.vue?vue&type=template&id=246b4dab&scoped=true&"
import script from "./MensagemUpgrade.vue?vue&type=script&lang=js&"
export * from "./MensagemUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./MensagemUpgrade.vue?vue&type=style&index=0&id=246b4dab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246b4dab",
  null
  
)

export default component.exports